import { create } from './Create/Create.i18n.ja'
import { importFromCsv } from './Import/Import.i18n.ja'
import { update } from './UpdateCustomer/Update.i18n.ja'

export const customers = {
  create,
  update,
  importFromCsv,
}
